import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=2f6851aa&scoped=true&"
import script from "./FileIcon.vue?vue&type=script&lang=js&"
export * from "./FileIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=2f6851aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6851aa",
  null
  
)

component.options.__file = "FileIcon.vue"
export default component.exports